import { faFilePdf, faFolder } from "@fortawesome/free-regular-svg-icons";
import React, { useContext } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { InfoBarContext } from "../../../common/info";
import { isTouch } from "../../../utils/screenUtil";
import RequestPreview from "./preview/RequestPreview";
import SubmittedDocumentation from "./preview/SubmittedDocumentation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PUT } from "../../../utils/fetchUtil";
import { MessageContext } from "../../../common/message";
import { getAccessToken } from "../../../common/authorization/AuthorizeService";
import Tooltip from "../../../common/tooltip/Tooltip";

function Solved({ title, requests, activeJournalId, setActiveJournalId }) {
  const infoBar = useContext(InfoBarContext);
  const { t } = useTranslation();
  const history = useHistory();
  const message = useContext(MessageContext);

  const confirmation = (id, uid, url) => {
    PUT(
      `/requests/${id}/submissions/${uid}/decision`,
      null,
      async () => {
        fetch(`${process.env.REACT_APP_GATEWAY_URL}${url}`, {
          method: "GET",
          headers: {
            "Request-Origin": "portal",
            Authorization: "Bearer " + (await getAccessToken()),
          },
          mode: "cors",
          credentials: "include",
        })
          .then((response) => response.blob())
          .then((file) => window.open(URL.createObjectURL(file)));
      },
      (error) => {
        message.toggle({
          title: t("requests.overview.supplement.infoBar.errorTitle"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
  };

  return (
    <>
      <div className="subtitle">{title}</div>
      {requests &&
        requests.map((request, index) => (
          <RequestPreview
            className={isTouch() && index > 0 ? "mt-6" : ""}
            key={`solved${index}`}
            {...request}
            blur={activeJournalId && activeJournalId !== request.uid}
            setActiveJournalId={setActiveJournalId}
            renderRequestActions={() => (
              <Tooltip
                content={"Predana dokumentacija"}
                children={
                  <FontAwesomeIcon
                    className="is-clickable"
                    icon={faFolder}
                    onClick={() => {
                      setActiveJournalId(request.uid);
                      infoBar.toggle(
                        t("requests.overview.solved.submittedDocumentation.title"),
                        () => (
                          <SubmittedDocumentation
                            letters={request.letters}
                            attachments={request.attachments}
                            finances={request.finances}
                          />
                        )
                      );
                    }}
                    size="2x"
                  />
                }
              ></Tooltip>
            )}
            renderDecisionActions={() =>
              request.decisionUrl && (
                <Tooltip
                  content={"Rezultat predanog zahtjeva"}
                  children={
                    <FontAwesomeIcon
                      className="is-clickable has-text-danger" //ml-4
                      icon={faFilePdf}
                      size="2x"
                      onClick={() => {
                        confirmation(request.id, request.uid, request.decisionUrl);
                      }}
                    />
                  }
                ></Tooltip>
              )
            }
          />
        ))}
    </>
  );
}

export default Solved;
